var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.asyncLoading)?_c('div',{staticClass:"subscription-flow-v2"},[(_vm.isPayment)?_c('purchase-offering-payment',{attrs:{"done":_vm.goToDone}}):_c('purchase-offering-done')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }